"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaScreen = exports.Device = void 0;
var lodash_1 = require("lodash");
var Device;
(function (Device) {
    /** Width below `767px` */
    Device["Mobile"] = "mobile";
    /** Width between `768px` and `991px` */
    Device["Tablet"] = "tablet";
    /** Width above `1200px` */
    Device["Desktop"] = "desktop";
})(Device = exports.Device || (exports.Device = {}));
/** Sets media breakpoints for responsive layouts. */
var mediaScreen = function (_a) {
    var style = _a.style, device = _a.device, _b = _a.orientation, orientation = _b === void 0 ? undefined : _b;
    var CSSString = '';
    for (var key in style) {
        CSSString += lodash_1.kebabCase(key) + ':';
        CSSString += style[key] + ';';
    }
    if (device === Device.Mobile) {
        return "@media only screen and (max-width: 767px) " + (orientation ? "and (orientation: " + orientation + ")" : '') + " {\n      " + CSSString + "\n    }";
    }
    if (device === Device.Tablet) {
        return "@media only screen and (min-width: 768px) and (max-width: 991px) " + (orientation ? "and (orientation: " + orientation + ")" : '') + " {\n      " + CSSString + "\n    }";
    }
    return "@media only screen and (min-width: 1200px) {\n    " + CSSString + "\n  }";
};
exports.mediaScreen = mediaScreen;
//# sourceMappingURL=mediaScreen.js.map